import { memo } from 'react'
import CarModalInput from '../../../../inputs/CarModalInput'

function SelectKm({ km, setKm }) {
  return (
    <>
      <h5 className="text-xl font-medium text-right mt-10 mb-4 dark:text-gray-200">
        در صورتی که کیلومتر مورد نظر در گرینه های بالا وجود ندارد عدد مد نظر خود را در بخش زیر وارد
        کنید
      </h5>
      <div className="max-w-[300px]">
        <CarModalInput
          maxLength={9}
          type={'number'}
          name={'km'}
          value={km}
          inputHandler={(e) => setKm(parseInt(e.target.value))}
        />
      </div>
    </>
  )
}

export default memo(SelectKm)
